import { render, staticRenderFns } from "./complaints-table.vue?vue&type=template&id=143301c2"
import script from "./complaints-table.vue?vue&type=script&lang=js"
export * from "./complaints-table.vue?vue&type=script&lang=js"
import style0 from "./complaints-table.vue?vue&type=style&index=0&id=143301c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports